module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollMain",
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "article-block article-block1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article-main"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                            Солнечная бодрость Сицилии\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Сицилия — яркий и солнечный остров, омываемый тремя морями.\n                            Смотрите видео о том, как природа этого острова зовет к приключениям!\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 1')
      }
    }
  }, [_vm._v("\n                            Cмотреть\n                            "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "article-block article-block2"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "article-main"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                            Лимонные ароматы Палермо\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Увлекательное видео из биодинамического лимонного сада, цветущего неподалеку от прибрежного сицилийского города.\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 2')
      }
    }
  }, [_vm._v("\n                            Cмотреть\n                            "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])], 1)]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "article-block article-block3"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "quotes-img2 animate-img"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "article-main"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                            Природная гармония в Швебиш-Гмюнде\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go to longread 3')
      }
    }
  }, [_vm._v("\n                            Cмотреть\n                            "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    В каждое путешествие я собираюсь с чувством, что меня ждет что-то новое и интересное. Вот и на этот раз поездка получилась насыщенной и познавательной\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left animate-block"
  }, [_c('div', {
    staticClass: "img img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article1/front-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img2 delay3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article1/back-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img3 delay6"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes-img animate-img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article2/img1.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Почти все свое детство я провела в Крыму у бабушки. Часто я помогала ей собирать фрукты для компота.\n                    Но вот собирать лимоны на Сицилии для создания органической косметики — это очень приятный и новый опыт\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right animate-block"
  }, [_c('div', {
    staticClass: "img img1"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article2/front-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img2 delay3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article2/back-lem.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img3 delay6 animate-img"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes-img animate-img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article3/img1.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Швебиш-Гмюнд — очень милый небольшой городок с пряничными домиками, в пригороде которого есть сказочный сад\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left animate-block"
  }, [_c('div', {
    staticClass: "img img1 "
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article3/front-gr.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img img2 delay3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/article3/back-gr.jpg",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0130ad66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/pageMain.vue
// module id = 531
// module chunks = 1